import React from 'react';
import classes from '../styles/style.module.css'
import CustomModal from '../../../assets/components/ModalComonent';
import HubbleButton from './HubbleButton';
import { GrDocumentDownload } from "react-icons/gr";

const RegulationDialog = ({ open, onClose }) => {
    const AwardsContent =
        <div>
            <img src='/images/hubble/dialogs/rules.png' className='w-75' alt='awards' />
            <h4 className={classes.dialogHeading}>آیین نامه</h4>
            <p style={{ textAlign: 'justify' }}>
                مطالعه آیین‌نامه رویداد استعداد‌یابی هابل برای تمامی شرکت‌کنندگان الزامی است،  این آیین‌نامه شامل تمامی قوانین، شرایط و الزامات شرکت در مسابقه، نحوه ارزیابی، حقوق و مسئولیت‌های شرکت‌کنندگان و برگزارکنندگان است. شرط اصلی برای حضور در این رویداد، آگاهی کامل و پذیرش مفاد آیین‌نامه بوده و عدم مطالعه و رعایت آن ممکن است منجر به حذف فرد از رقابت شود. لذا توصیه می‌شود تمامی متقاضیان پیش از ثبت‌نام، آیین‌نامه را به‌دقت مطالعه کرده و نسبت به تمامی بندهای آن متعهد باشند.
            </p>
            <div>
                <HubbleButton onClick={() => window.open("http://dl.rahebehesht.com/%D8%A2%DB%8C%DB%8C%D9%86%20%D9%86%D8%A7%D9%85%D9%87%20%D9%87%D8%A7%D8%A8%D9%84.pdf", '_blank')} >
                    <GrDocumentDownload className='ml-2' />
                    دانلود آیین نامه
                </HubbleButton>
            </div>
        </div>

    return (
        <div>
            <CustomModal
                yellow
                open={open}
                closeHandler={onClose}
                inputDialog={true}
                dialogContent={AwardsContent}
            />
        </div>
    )
}

export default RegulationDialog